import React from 'react'

import config from '../config.js'

import { MuiThemeProvider } from '@material-ui/core/styles'

import Chat from './Chat'
import LoadingIcon from './LoadingIcon'
import Participants from './Participants'

class Conversations extends React.Component {
  render() {
    let conversationList = ''
    let conversationItems = ''
    let chatsWithUnseenMessages = 0

    if (this.props.conversations !== undefined) {
      if (this.props.conversations.length > 0) {
        // Filter out the conversations that have no chats
        conversationItems = this.props.conversations.filter(
          item => item.chats !== undefined && item.chats.length > 0
        )

        // Now we need to sort the array of conversations in reverse chronological order according to the most recent chat message
        conversationItems.sort(function(a, b) {
          return (
            parseFloat(b['chats'][b['chats'].length - 1]['dateCreated']) -
            parseFloat(a['chats'][a['chats'].length - 1]['dateCreated'])
          )
        })

        // Now build a list of participants and find the most recent chat to display as a representative sample of the conversation
        conversationItems = conversationItems.map(item => {
          const conversationParticipants = (
            <Participants
              aid={this.props.aid}
              participants={item.participants}
            />
          )

          // Count the unseen messages
          chatsWithUnseenMessages = item.chats.filter(chat => {
            let hasBeenSeen = false
            let seenBy = undefined

            if (chat.seenBy !== undefined) {
              seenBy = chat.seenBy
              seenBy = seenBy.filter(item => item === this.props.aid)
            }

            if (seenBy === undefined || seenBy.length === 0) {
              // hasBeenSeen is already false
            } else if (seenBy.length > 0) {
              // Mark the status as seen here in React
              hasBeenSeen = true
            }

            if (hasBeenSeen) return false
            else return true
          })

          const unseenMessageCount = chatsWithUnseenMessages.length

          let lastChat = undefined
          if (item.chats !== undefined) {
            lastChat = item.chats.filter(chat => {
              if (chat.accountId !== this.props.aid) return true
              else return false
            })
            if (lastChat.length > 0) {
              lastChat = lastChat[lastChat.length - 1]
            } else {
              const tempChat = item.chats[item.chats.length - 1]

              lastChat = {
                accountId: 'system', // This will make sure the chat system message isn't treated as the user's
                chatId: tempChat.chatId,
                conversationId: tempChat.conversationId,
                dateCreated: tempChat.dateCreated,
                message: "Your friend hasn't responded yet",
                published: tempChat.published,
                seenBy: [this.props.aid] // This will make sure the chat system message won't be marked as unread
              }
            }

            return (
              <Chat
                key={item.conversationId}
                aid={this.props.aid}
                linkToConversation={true}
                unseenMessagesCount={unseenMessageCount}
                sender={conversationParticipants}
                chat={lastChat}
              />
            )
          } else {
            return <span />
          }
        })

        conversationList = (
          <ul className="conversation-list">{conversationItems}</ul>
        )
      } else {
        conversationList = (
          <div className="warning text-center">No Conversations Found</div>
        )
      }
    } else {
      conversationList = (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <LoadingIcon />
        </div>
      )
    }
    return (
      <div className="conversation-container">
        <MuiThemeProvider theme={config.theme}>
          <h2 className="text-center">Cook'n Messages</h2>
          {conversationList}
        </MuiThemeProvider>
      </div>
    )
  }
}

export default Conversations



// WEBPACK FOOTER //
// ./src/Components/Conversations.js